'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _compliantMembers = require('./compliant-members.component');

var _compliantMembers2 = _interopRequireDefault(_compliantMembers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.member-compliance.compliant-members', []).component('compliantMembers', _compliantMembers2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/compliant-members/compliant-members.module.js